import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { Divider } from '~/components/elements/Divider'
import { ShowMoreDescription } from '~/components/modules/ShowMoreDescription/ShowMoreDescription'
import { LabeledDefinition } from '~/features/shared/item/components/LabeledDefinition'

const ItemDescription: React.FC<{ content: string }> = ({ content }) => {
  return (
    <section className="flex flex-col gap-[10px] pr-[23px]">
      <h2 className="text-[16px] font-bold leading-none">アイテム説明</h2>
      <ShowMoreDescription content={content} rowLength={8} />
    </section>
  )
}

type Item = Pick<
  Schemas.item_large,
  'content' | 'keywords' | 'category' | 'variations' | 'id'
>

// eslint-disable-next-line complexity
const ItemDetail: React.FC<{ item: Item }> = ({ item }) => {
  const categoryPath =
    item.category.id !== null
      ? `/item/?type_category_id=${item.category.id}`
      : '/item/?type_category_id=124'
  const childCategoryPath =
    item.category.child_category.id !== null
      ? `${categoryPath}&category_id=${item.category.child_category.id}`
      : ''
  const sizes = item.variations?.sizes
    ?.map((size) => size?.name)
    .filter(Boolean)
    .join(',')

  const keywordsExist = item.keywords && item.keywords.length > 0

  return (
    <section>
      <h2 className="text-[16px] font-bold leading-none">アイテム詳細</h2>
      <dl className="grid grid-cols-[90px_271px] gap-x-[5px] gap-y-[6px] pt-[10px] text-[14px]">
        {sizes && <LabeledDefinition term="サイズ">{sizes}</LabeledDefinition>}
        <LabeledDefinition term="カテゴリー">
          <div className="flex flex-wrap gap-[6px]">
            <Chip href={categoryPath}>
              {item.category.id !== null ? item.category.name : 'その他'}
            </Chip>
            {childCategoryPath && (
              <Chip href={childCategoryPath}>
                {item.category.child_category.name}
              </Chip>
            )}
          </div>
        </LabeledDefinition>
        {keywordsExist && (
          <LabeledDefinition term="キーワード">
            <div className="flex flex-wrap gap-[6px]">
              {item.keywords?.map((keyword) => {
                if (keyword.name === '') return null
                return (
                  <Chip
                    key={keyword.id}
                    href={`/item/?search_word=${keyword.name})`}
                  >
                    {keyword.name}
                  </Chip>
                )
              })}
            </div>
          </LabeledDefinition>
        )}
      </dl>
    </section>
  )
}

type Props = {
  item: Item
}

export const ItemDetailForPc: React.FC<Props> = ({ item }) => {
  return (
    <div className="flex w-[414px] flex-col gap-[22px] rounded-[3px] border border-gray-300 bg-white pb-[23px] pl-[23px] pt-6">
      {item.content && (
        <div className="flex flex-col gap-[19px]">
          <ItemDescription content={item.content} />
          <Divider />
        </div>
      )}
      <ItemDetail item={item} />
    </div>
  )
}
